import { Toast } from 'bootstrap';

/**
 * Toast
 */
export function initToast(elem) {
    let toastsTriggerList = [].slice.call(elem.querySelectorAll('[data-bs-toggle="toast"]'));
    toastsTriggerList.map(function (toastTriggerEl) {
        if (!toastTriggerEl.hasAttribute('data-bs-target')) {
            return;
        }

        const toastEl = new Toast(toastTriggerEl.getAttribute('data-bs-target'));
        toastsTriggerList.addEventListener("change", function () {
            if (!toastsTriggerList.dataset.originalClass) {
                toastsTriggerList.dataset.originalClass = toastsTriggerList.className;
            }
            toastsTriggerList.className = toastsTriggerList.dataset.originalClass + " " + this.value;
        });
        toastTriggerEl.addEventListener('click', () => {
            toastEl.show()
        });
    });
}
initToast(document);
